



























































































































































































import { Component, Prop } from 'vue-property-decorator'
import ProgressRotate from '../atoms_molecules/ProgressRotate.vue'
import DialogDeleteConfirm from '../atoms_molecules/DialogDeleteConfirm.vue'
import DialogDeleteExamConfirm from '../atoms_molecules/DialogDeleteExamConfirm.vue'
import { format } from 'date-fns'
import { mixins } from 'vue-class-component'
import ExamMixin from './ExamMixin'
import Exam from '../../models/exam'
import UserExam from '../../models/user_exam'
import { ROUTER_NAME } from '../../router'
import SchoolSetting from '../../../api/v2/models/school_setting'
import flatten from 'lodash/flatten'

interface HistoryType {
  exam: Exam
  userExam: UserExam
  btnName: string
  title?: string
}

@Component({
  components: {
    ProgressRotate,
    DialogDeleteConfirm,
    DialogDeleteExamConfirm
  }
})
export default class ExamComponent extends mixins(ExamMixin) {
  @Prop({ required: true }) exam: Exam
  @Prop({ default: ()=> {return []} }) list: Exam[]
  @Prop({ default: false }) isMine: boolean
  @Prop({ required: true }) schoolSetting: SchoolSetting
  @Prop({ default: null }) onShowHistories!: ((exam: Exam) => void) | null
  @Prop({ default: false }) onlyAction: boolean
  @Prop({ default: null }) userExam: UserExam | null
  isMobile: boolean = false

  get latestHistory() {
    return this.allHistories[0]
  }

  get showingHistories() {
    return this.allHistories.slice(1, this.allHistories.length)
  }

  get oldestHistory() {
    return this.allHistories[this.allHistories.length - 1]
  }

  get childrenExams() {
    return this.getChildOfExam(this.exam, this.list)
  }

  get isNoHistory() {
    return this.allHistories.length == 1
  }

  getChildOfExam(exam: Exam, examList: Exam[]): Exam[] {
    const childOfExams = examList.filter((item) => item.parentId == exam.id)
    return flatten([childOfExams, ...childOfExams.map((child) => this.getChildOfExam(child, examList))])
  }

  get currentUserExam(){
    return this.userExam ? this.userExam : this.latestHistory.userExam
  }

  get isShowResult() {
    return (
      this.latestHistory.exam.isDone(this.currentUserExam) &&
      !this.currentUserExam.isWaitingScoreCheck &&
      !this.latestHistory.exam.hideResult
    )
  }

  get allHistories(): HistoryType[] {
    const histories: HistoryType[] = []

    this.exam.userExams.forEach((userExam) => {
      histories.push({
        exam: this.exam,
        userExam,
        btnName: this.btnName(this.exam, userExam)
      })
    })

    this.childrenExams.forEach((exam) => {
      exam.userExams.forEach((userExam) => {
        histories.push({
          exam,
          userExam,
          btnName: this.btnName(exam, userExam)
        })
      })
    })

    let ascHistories = histories.sort((a, b) => {
      if (a.userExam.createdAt < b.userExam.createdAt) {
        return -1
      }
      if (a.userExam.createdAt == b.userExam.createdAt) {
        return 0
      }

      return 1
    })

    const testFromFaildExam: Exam[] = []
    const result: HistoryType[] = []
    ascHistories.forEach((history, index) => {
      let title = ''
      if (index == 0) {
        testFromFaildExam.push(history.exam)
        title = history.exam.name
      } else if (testFromFaildExam.find((item) => item.id == history.exam.id)) {
        title = `再テスト${index} − 同じ問題`
      } else {
        testFromFaildExam.push(history.exam)
        switch (history.exam.examType) {
          case Exam.TYPE_USE_NIGATE_EXAM:
            title = `再テスト${index} − ニガテ`
            break
          case Exam.TYPE_USE_SPECIAL_EXAM:
            title = `再テスト${index} − 別質問`
            break
          case Exam.TYPE_USE_EXAM_FROM_FAILED:
            title = `再テスト${index} − 前回マチガイ再テスト`
            break
          default:
            title = `再テスト${index}`
            break
        }
      }

      result.push({
        ...history,
        title
      })
    })

    return result.reverse()
  }

  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  }

  dateFormat(date: Date) {
    return format(date, 'YYYY/MM/DD HH:mm')
  }

  btnName(exam: Exam, userExam: UserExam) {
    if (!exam.isStarted(userExam)) {
      return this.$t('exam_list.start') as string
    }
    if (exam.isTestTimeOver(userExam)) {
      return this.$t('exam_list.time_over') as string
    }
    return this.$t('exam_list.continue') as string
  }

  onResize() {
    this.isMobile = window.innerWidth < 600
  }

  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize)
    }
  }

  goToUserExamHistory(exam: Exam, userExam: UserExam) {
    if (this.currentUserExam.isWaitingScoreCheck) return

    this.$router.push({
      name: userExam.finishedAt ? ROUTER_NAME.EXAM_RESULT : ROUTER_NAME.EXAM_SHOW,
      params: {
        examId: exam.id.toString()
      },
      query: {
        user_exam_id: userExam.id.toString()
      }
    })
  }
}
